export default "__VITE_ASSET__C4HdFRs9__"